import React, { useState, useEffect,useRef } from 'react';
import images from '../files/images'
import styled from 'styled-components';
import Draggable from 'react-draggable';

import { useMediaQuery } from 'react-responsive'


import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
//components

import { Menu } from '../components/Menu'
import { About } from './about'
import { Docs } from './docs'
import { Projects } from './projects'
import { Contact } from './contact'

const Wrapper = styled.div`
  background-image: ${props => props.image};
  background-position: bottom center;
  background-repeat:no-repeat; 
  background-size: cover;
  background-attachment: fixed;
  min-height:100vh;
`;

const Drag = styled.div`
  display: inline block;
  max-width: 90vw;
  @media (max-width: 800px) {
    margin-top: 5vh;
    margin-bottom: 10vh;
  }
`;


export const Main = (props) => {
    let images_url = images;
    let images_length = images.length;

    const [newCurrentImg, setNewCurrentImg] = useState(0);
    const [currentImg, setCurrentImg] = useState(images_url[newCurrentImg])
    const nodeRef = useRef(null);

    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })



    useEffect(() => {
        const interval = setInterval(() => {
            if (newCurrentImg < images_length - 1) {
                setNewCurrentImg(newCurrentImg => newCurrentImg + 1);

            } else {
                setNewCurrentImg(newCurrentImg => 0);
            }
            setCurrentImg(images_url[newCurrentImg])
        }, 3000);
        return () => {
            clearInterval(interval);
        }
    });
    const urlString = `url('${currentImg}')`;
    return (
        
        <Router>

            <Wrapper image={urlString} style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                
                <Draggable
                    bounds="#root"
                    handle='#drag'
                    disabled={isPortrait ? true : false}
                >
                    <Drag id="drag"  className="d-flex justify-content-center">

                        <Switch>
                            <Route exact path='/' component={About} />
                        </Switch>

                        <Switch>
                            <Route exact path='/docs' component={Docs} />
                        </Switch>

                        <Switch>
                            <Route exact path='/projects' component={Projects} />
                        </Switch>

                        <Switch>
                            <Route exact path='/contact' component={Contact} />
                        </Switch>

                    </Drag>
                </Draggable >
                <Menu />
            </Wrapper>

        </Router>


    )
}

